var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudSpend(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H20C24.4183 0 28 3.58172 28 8V20C28 24.4183 24.4183 28 20 28H8C3.58172 28 0 24.4183 0 20V8Z",
    fill: "#057DCD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1831_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 13.9999C20.368 13.9999 20.67 13.7006 20.6333 13.3346C20.4796 11.8041 19.8014 10.3737 18.7136 9.28616C17.6257 8.19857 16.1953 7.52064 14.6647 7.36728C14.298 7.33061 13.9993 7.63261 13.9993 8.00061V13.3339C13.9993 13.5108 14.0696 13.6803 14.1946 13.8054C14.3196 13.9304 14.4892 14.0006 14.666 14.0006L20 13.9999Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.14 16.5934C19.7159 17.5964 19.0525 18.4802 18.2079 19.1676C17.3633 19.855 16.3632 20.325 15.295 20.5366C14.2267 20.7481 13.1229 20.6948 12.0801 20.3813C11.0372 20.0677 10.0871 19.5034 9.31268 18.7378C8.53828 17.9722 7.96321 17.0286 7.63776 15.9894C7.3123 14.9501 7.24637 13.847 7.44573 12.7765C7.64509 11.7059 8.10366 10.7005 8.78136 9.84807C9.45906 8.99567 10.3353 8.32226 11.3333 7.88672",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1831_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudSpend);
export default __webpack_public_path__ + "static/media/CloudSpend.1fd2cf818be9ef77db279d760f0dbb43.svg";
export { ForwardRef as ReactComponent };